// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-error-page {
  min-height: 600px;
  margin: 0px auto;
  width: auto;
  max-width: 560px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.error-title {
  max-width: 529px; 
  font-family: Roboto;
  font-size: 38px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4b4b62;
  margin-bottom: 16px;
}

.error-subtitle {
  max-width: 568px; 
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #4b4b62;
  margin-bottom: 24px;
}
svg {
  margin-bottom: 16px;
}


.full-torradeira {
   
}
.torradeira {
}

.pao-atras {
  animation: leftright 1s alternate infinite;
  transform-origin: center;
}
.pao-frente {
    animation: leftright 1s 0.3s alternate infinite;
  transform-origin: center;
}

.olho-esq {
  
    animation: sad 2s alternate infinite;
  transform-origin: center;
}

.olho-dir {
  
    animation: sad 2s alternate infinite;
  transform-origin: center;
}
.boca {
    animation: sad 2s alternate infinite;
  transform-origin: center;
}
.raios {
  animation: flicker-4 4s linear infinite both;
}
.tomada {
	 animation: vibrate-1 3s linear infinite both;
}
.fio-500 {
	 animation: vibrate-1 3s linear infinite both;
}
.fio{
	 animation: vibrate-1 3s linear infinite both;
}

@keyframes scales {
  from {
    transform: scale(0.98);
  }
  to {
    transform: scale(1);
  }
}

/* ----------------------------------------------
 * Generated by Animista on 2020-4-1 14:58:16
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation flicker-4
 * ----------------------------------------
 */
@keyframes flicker-4 {
  0%,
  100% {
    opacity: 1;
  }
  31.98% {
    opacity: 1;
  }
  32% {
    opacity: 0;
  }
  32.8% {
    opacity: 0;
  }
  32.82% {
    opacity: 1;
  }
  34.98% {
    opacity: 1;
  }
  35% {
    opacity: 0;
  }
  35.7% {
    opacity: 0;
  }
  35.72% {
    opacity: 1;
  }
  36.98% {
    opacity: 1;
  }
  37% {
    opacity: 0;
  }
  37.6% {
    opacity: 0;
  }
  37.62% {
    opacity: 1;
  }
  67.98% {
    opacity: 1;
  }
  68% {
    opacity: 0;
  }
  68.4% {
    opacity: 0;
  }
  68.42% {
    opacity: 1;
  }
  95.98% {
    opacity: 1;
  }
  96% {
    opacity: 0;
  }
  96.7% {
    opacity: 0;
  }
  96.72% {
    opacity: 1;
  }
  98.98% {
    opacity: 1;
  }
  99% {
    opacity: 0;
  }
  99.6% {
    opacity: 0;
  }
  99.62% {
    opacity: 1;
  }
}


/* ----------------------------------------------
 * Generated by Animista on 2020-4-1 15:17:57
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation vibrate-1
 * ----------------------------------------
 */
@keyframes vibrate-1 {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translate(-2px, 2px);
  }
  40% {
    transform: translate(-2px, -2px);
  }
  60% {
    transform: translate(2px, 2px);
  }
  80% {
    transform: translate(2px, -2px);
  }
  100% {
    transform: translate(0);
  }
}



/* ----------------------------------------------
 * Generated by Animista on 2020-4-1 15:42:45
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation wobble-ver-right
 * ----------------------------------------
 */
 

@keyframes sad {
  0% {
    transform: rotateX(0deg) rotateY(0deg);
  }
  100% {
    transform: rotateX(10deg)  rotateY(5deg);
  }
}

@keyframes leftright{
  
  0%{
    transform: rotateZ( 0deg)
  }
   100%{
    transform: rotateZ( -15deg)
  }
}`, "",{"version":3,"sources":["webpack://./src/app/out-of-application/InternalServerError/InternalServerError.component.css"],"names":[],"mappings":"AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;;AAGA;;AAEA;AACA;AACA;;AAEA;EACE,0CAA0C;EAC1C,wBAAwB;AAC1B;AACA;IACI,+CAA+C;EACjD,wBAAwB;AAC1B;;AAEA;;IAEI,oCAAoC;EACtC,wBAAwB;AAC1B;;AAEA;;IAEI,oCAAoC;EACtC,wBAAwB;AAC1B;AACA;IACI,oCAAoC;EACtC,wBAAwB;AAC1B;AACA;EAEE,4CAA4C;AAC9C;AACA;EAES,4CAA4C;AACrD;AACA;EAES,4CAA4C;AACrD;AACA;EAES,4CAA4C;AACrD;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;;;;;mDAKmD;;AAEnD;;;;EAIE;AA+EF;EACE;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;;AAGA;;;;;mDAKmD;;AAEnD;;;;EAIE;AA2BF;EACE;IAEU,uBAAuB;EACjC;EACA;IAEU,+BAA+B;EACzC;EACA;IAEU,gCAAgC;EAC1C;EACA;IAEU,8BAA8B;EACxC;EACA;IAEU,+BAA+B;EACzC;EACA;IAEU,uBAAuB;EACjC;AACF;;;;AAIA;;;;;mDAKmD;;AAEnD;;;;EAIE;;;AAgCF;EACE;IACE,sCAAsC;EACxC;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;;EAEE;IACE;EACF;GACC;IACC;EACF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');\r\n.main-error-page {\r\n  min-height: 600px;\r\n  margin: 0px auto;\r\n  width: auto;\r\n  max-width: 560px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n.error-title {\r\n  max-width: 529px; \r\n  font-family: Roboto;\r\n  font-size: 38px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #4b4b62;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.error-subtitle {\r\n  max-width: 568px; \r\n  font-family: Roboto;\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: 1.31;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #4b4b62;\r\n  margin-bottom: 24px;\r\n}\r\nsvg {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n\r\n.full-torradeira {\r\n   \r\n}\r\n.torradeira {\r\n}\r\n\r\n.pao-atras {\r\n  animation: leftright 1s alternate infinite;\r\n  transform-origin: center;\r\n}\r\n.pao-frente {\r\n    animation: leftright 1s 0.3s alternate infinite;\r\n  transform-origin: center;\r\n}\r\n\r\n.olho-esq {\r\n  \r\n    animation: sad 2s alternate infinite;\r\n  transform-origin: center;\r\n}\r\n\r\n.olho-dir {\r\n  \r\n    animation: sad 2s alternate infinite;\r\n  transform-origin: center;\r\n}\r\n.boca {\r\n    animation: sad 2s alternate infinite;\r\n  transform-origin: center;\r\n}\r\n.raios {\r\n  -webkit-animation: flicker-4 4s linear infinite both;\r\n  animation: flicker-4 4s linear infinite both;\r\n}\r\n.tomada {\r\n  -webkit-animation: vibrate-1 3s linear infinite both;\r\n\t        animation: vibrate-1 3s linear infinite both;\r\n}\r\n.fio-500 {\r\n  -webkit-animation: vibrate-1 3s linear infinite both;\r\n\t        animation: vibrate-1 3s linear infinite both;\r\n}\r\n.fio{ \r\n  -webkit-animation: vibrate-1 3s linear infinite both;\r\n\t        animation: vibrate-1 3s linear infinite both;\r\n}\r\n\r\n@keyframes scales {\r\n  from {\r\n    transform: scale(0.98);\r\n  }\r\n  to {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n/* ----------------------------------------------\r\n * Generated by Animista on 2020-4-1 14:58:16\r\n * Licensed under FreeBSD License.\r\n * See http://animista.net/license for more info. \r\n * w: http://animista.net, t: @cssanimista\r\n * ---------------------------------------------- */\r\n\r\n/**\r\n * ----------------------------------------\r\n * animation flicker-4\r\n * ----------------------------------------\r\n */\r\n@-webkit-keyframes flicker-4 {\r\n  0%,\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n  31.98% {\r\n    opacity: 1;\r\n  }\r\n  32% {\r\n    opacity: 0;\r\n  }\r\n  32.8% {\r\n    opacity: 0;\r\n  }\r\n  32.82% {\r\n    opacity: 1;\r\n  }\r\n  34.98% {\r\n    opacity: 1;\r\n  }\r\n  35% {\r\n    opacity: 0;\r\n  }\r\n  35.7% {\r\n    opacity: 0;\r\n  }\r\n  35.72% {\r\n    opacity: 1;\r\n  }\r\n  36.98% {\r\n    opacity: 1;\r\n  }\r\n  37% {\r\n    opacity: 0;\r\n  }\r\n  37.6% {\r\n    opacity: 0;\r\n  }\r\n  37.62% {\r\n    opacity: 1;\r\n  }\r\n  67.98% {\r\n    opacity: 1;\r\n  }\r\n  68% {\r\n    opacity: 0;\r\n  }\r\n  68.4% {\r\n    opacity: 0;\r\n  }\r\n  68.42% {\r\n    opacity: 1;\r\n  }\r\n  95.98% {\r\n    opacity: 1;\r\n  }\r\n  96% {\r\n    opacity: 0;\r\n  }\r\n  96.7% {\r\n    opacity: 0;\r\n  }\r\n  96.72% {\r\n    opacity: 1;\r\n  }\r\n  98.98% {\r\n    opacity: 1;\r\n  }\r\n  99% {\r\n    opacity: 0;\r\n  }\r\n  99.6% {\r\n    opacity: 0;\r\n  }\r\n  99.62% {\r\n    opacity: 1;\r\n  }\r\n}\r\n@keyframes flicker-4 {\r\n  0%,\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n  31.98% {\r\n    opacity: 1;\r\n  }\r\n  32% {\r\n    opacity: 0;\r\n  }\r\n  32.8% {\r\n    opacity: 0;\r\n  }\r\n  32.82% {\r\n    opacity: 1;\r\n  }\r\n  34.98% {\r\n    opacity: 1;\r\n  }\r\n  35% {\r\n    opacity: 0;\r\n  }\r\n  35.7% {\r\n    opacity: 0;\r\n  }\r\n  35.72% {\r\n    opacity: 1;\r\n  }\r\n  36.98% {\r\n    opacity: 1;\r\n  }\r\n  37% {\r\n    opacity: 0;\r\n  }\r\n  37.6% {\r\n    opacity: 0;\r\n  }\r\n  37.62% {\r\n    opacity: 1;\r\n  }\r\n  67.98% {\r\n    opacity: 1;\r\n  }\r\n  68% {\r\n    opacity: 0;\r\n  }\r\n  68.4% {\r\n    opacity: 0;\r\n  }\r\n  68.42% {\r\n    opacity: 1;\r\n  }\r\n  95.98% {\r\n    opacity: 1;\r\n  }\r\n  96% {\r\n    opacity: 0;\r\n  }\r\n  96.7% {\r\n    opacity: 0;\r\n  }\r\n  96.72% {\r\n    opacity: 1;\r\n  }\r\n  98.98% {\r\n    opacity: 1;\r\n  }\r\n  99% {\r\n    opacity: 0;\r\n  }\r\n  99.6% {\r\n    opacity: 0;\r\n  }\r\n  99.62% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n/* ----------------------------------------------\r\n * Generated by Animista on 2020-4-1 15:17:57\r\n * Licensed under FreeBSD License.\r\n * See http://animista.net/license for more info. \r\n * w: http://animista.net, t: @cssanimista\r\n * ---------------------------------------------- */\r\n\r\n/**\r\n * ----------------------------------------\r\n * animation vibrate-1\r\n * ----------------------------------------\r\n */\r\n@-webkit-keyframes vibrate-1 {\r\n  0% {\r\n    -webkit-transform: translate(0);\r\n            transform: translate(0);\r\n  }\r\n  20% {\r\n    -webkit-transform: translate(-2px, 2px);\r\n            transform: translate(-2px, 2px);\r\n  }\r\n  40% {\r\n    -webkit-transform: translate(-2px, -2px);\r\n            transform: translate(-2px, -2px);\r\n  }\r\n  60% {\r\n    -webkit-transform: translate(2px, 2px);\r\n            transform: translate(2px, 2px);\r\n  }\r\n  80% {\r\n    -webkit-transform: translate(2px, -2px);\r\n            transform: translate(2px, -2px);\r\n  }\r\n  100% {\r\n    -webkit-transform: translate(0);\r\n            transform: translate(0);\r\n  }\r\n}\r\n@keyframes vibrate-1 {\r\n  0% {\r\n    -webkit-transform: translate(0);\r\n            transform: translate(0);\r\n  }\r\n  20% {\r\n    -webkit-transform: translate(-2px, 2px);\r\n            transform: translate(-2px, 2px);\r\n  }\r\n  40% {\r\n    -webkit-transform: translate(-2px, -2px);\r\n            transform: translate(-2px, -2px);\r\n  }\r\n  60% {\r\n    -webkit-transform: translate(2px, 2px);\r\n            transform: translate(2px, 2px);\r\n  }\r\n  80% {\r\n    -webkit-transform: translate(2px, -2px);\r\n            transform: translate(2px, -2px);\r\n  }\r\n  100% {\r\n    -webkit-transform: translate(0);\r\n            transform: translate(0);\r\n  }\r\n}\r\n\r\n\r\n\r\n/* ----------------------------------------------\r\n * Generated by Animista on 2020-4-1 15:42:45\r\n * Licensed under FreeBSD License.\r\n * See http://animista.net/license for more info. \r\n * w: http://animista.net, t: @cssanimista\r\n * ---------------------------------------------- */\r\n\r\n/**\r\n * ----------------------------------------\r\n * animation wobble-ver-right\r\n * ----------------------------------------\r\n */\r\n@-webkit-keyframes wobble-ver-right {\r\n  0%,\r\n  100% {\r\n    -webkit-transform: translateY(0) rotate(0);\r\n            transform: translateY(0) rotate(0);\r\n    -webkit-transform-origin: 50% 50%;\r\n            transform-origin: 50% 50%;\r\n  }\r\n  15% {\r\n    -webkit-transform: translateY(-30px) rotate(6deg);\r\n            transform: translateY(-30px) rotate(6deg);\r\n  }\r\n  30% {\r\n    -webkit-transform: translateY(15px) rotate(-6deg);\r\n            transform: translateY(15px) rotate(-6deg);\r\n  }\r\n  45% {\r\n    -webkit-transform: translateY(-15px) rotate(3.6deg);\r\n            transform: translateY(-15px) rotate(3.6deg);\r\n  }\r\n  60% {\r\n    -webkit-transform: translateY(9px) rotate(-2.4deg);\r\n            transform: translateY(9px) rotate(-2.4deg);\r\n  }\r\n  75% {\r\n    -webkit-transform: translateY(-6px) rotate(1.2deg);\r\n            transform: translateY(-6px) rotate(1.2deg);\r\n  }\r\n}\r\n \r\n\r\n@keyframes sad {\r\n  0% {\r\n    transform: rotateX(0deg) rotateY(0deg);\r\n  }\r\n  100% {\r\n    transform: rotateX(10deg)  rotateY(5deg);\r\n  }\r\n}\r\n\r\n@keyframes leftright{\r\n  \r\n  0%{\r\n    transform: rotateZ( 0deg)\r\n  }\r\n   100%{\r\n    transform: rotateZ( -15deg)\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
